// Checks if the value contains any of the specified items and replaces it with an empty string
export const cleanAddressField = (value: string | null | undefined): string => {
    if (!value || ['--', '-', '---', '0', '00', 'N/A', ''].includes(value))
        return '';
    return value;
};

export const fixedToTwoDecimals = (num: number) => {
    return (Math.round(num * 100) / 100).toFixed(2).replace(/\.00$/, '');
};

export const formatNumbersInEuropeanFormat = (
    num: number,
    lang: string,
    fraction = 2
) => {
    let formattedNum = '';
    if (+num < 0) {
        num = Math.abs(+num);
        formattedNum = '-';
    }
    formattedNum += (Math.round(num * 100) / 100).toLocaleString(
        lang === 'english' ? 'en-US' : 'da-DK',
        {
            minimumFractionDigits: fraction,
            maximumFractionDigits: fraction,
        }
    );
    return formattedNum;
};

export const normalizeLanguage = (lang?: string): string => {
    if (!lang) return 'en';

    const langMapping: Record<string, string> = {
        dansk: 'da',
        danish: 'da',
        english: 'en',
        engelsk: 'en',
    };
    const lower = lang.toLowerCase();
    return langMapping[lower] ?? lower;
};
